import * as React from 'react';
import {scrollIntoView} from "../Helpers/scrollTo";
import {useTranslation} from "react-i18next";

interface IProps {
	category: string;
}

const ActionButton = ({category}: IProps) => {
	const {t} = useTranslation();

	if (category === "chatting") {
		return <button className="btn std-height" onClick={() => scrollIntoView("form_container")}>
			{t("Jetzt direkt chatten")}
		</button>

	}

	if (category === "livecams") {
		return <button className="btn std-height livecams-btn" onClick={() => scrollIntoView("form_container")}>
			{t("Direkt zu den Live-Cams")}
		</button>
	}

	if (category === "videos") {
		return <button className="btn std-height" onClick={() => scrollIntoView("top_container")}>
			{t("Videos ansehen")}
		</button>
	}

	return null;
};

export default ActionButton
